import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";

import TextLink from "../../../../components/TextLink";

export default function Socials() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "vi" ? "en" : "vi";
    i18n.changeLanguage(newLang);
  };

  return (
    <div className={"pb-4 text-lg flex gap-4 justify-center items-center"}>
      <TextLink href={"https://www.linkedin.com/in/huukhoa/"}>
        <Icon icon="openmoji:linkedin" width="30" height="30" />
      </TextLink>

      <TextLink href={"https://github.com/Aohkne"}>
        <Icon icon="openmoji:github" width="30" height="30" />
      </TextLink>

      <TextLink href={"https://huuwkhoa.vercel.app/"}>
        <Icon icon="openmoji:code-editor" width="30" height="30" />
      </TextLink>

      <div className="w-[1px] h-6 bg-gray-300 mx-1"></div>

      <button
        onClick={toggleLanguage}
        className="flex items-center hover:scale-110 transition-transform duration-200"
        title={
          i18n.language === "vi"
            ? "Switch to English"
            : "Chuyển sang tiếng Việt"
        }
      >
        {i18n.language === "vi" ? (
          <Icon icon="emojione-v1:flag-for-vietnam" width="25" height="25" />
        ) : (
          <Icon
            icon="emojione-v1:flag-for-united-kingdom"
            width="25"
            height="25"
          />
        )}
      </button>
    </div>
  );
}
